import ExecutionEnvironment from "@docusaurus/ExecutionEnvironment";

if (ExecutionEnvironment.canUseDOM && process.env.PROFILE === "prod") {
  const Sentry = require("@sentry/react");

  Sentry.init({
    dsn: "https://542521f6ac6b6f4e86dbb0335ccbb8f8@o4510884462985216.ingest.de.sentry.io/4510884571906128",
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      Sentry.browserTracingIntegration(),
    ],
    sendDefaultPii: false,
    environment: "prod",
  });
}
